import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { UserJoinRequestGateway } from 'src/app/application/gateway/UserJoinRequestGateway';
import { UserJoinRequest } from 'src/app/domain/models/UserJoinRequest';
import { ErrorMessageUtil } from '../../util/error-message-util';
import { BasicUser } from 'src/app/domain/models/User';

@Component({
  selector: 'app-closed-sale-join-request',
  templateUrl: './closed-sale-join-request.component.html',
  styleUrls: ['./closed-sale-join-request.component.css']
})
export class ClosedSaleJoinRequestComponent {

  @Output()
  handleCloseVisibility = new EventEmitter

  loading: boolean = false
  submit: boolean = false
  profile: BasicUser | undefined
  
  userJoinRequestFormGroup: FormGroup = this._formBuilder.group({
    guestEmail: ['', [Validators.required, Validators.email]],
  })

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _authService: AuthGateway,
    private readonly _userJoinRequestService: UserJoinRequestGateway,
    private readonly _messageService: MessageService,
    public readonly translate: TranslateService
  ) {
    this.profile = this._authService.getUser()
  }

  saveUserJoinRequest() {
    this.loading = true
    this.submit = true
    if(this.userJoinRequestFormGroup.valid) {
      let request: UserJoinRequest = {
        hostUsername: this._authService.getUsername(),
        guestEmail: this.userJoinRequestFormGroup.controls['guestEmail'].value.toString().trim()
      }

      this._userJoinRequestService.create(request).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.UserJoinRequest.CreateSuccess') });
          this.submit = false
          this.loading = false
          this.onClose()
        },
        error: (e) => {
          this.loading = false

          const responseError = ErrorMessageUtil.getResponseError(e.error, this.profile?.lang);
          let errorDetail = responseError ? responseError : this.translate.instant('MessageService.UserJoinRequest.CreateError')

          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail:  errorDetail});
        }
      })
    }
    else {
      this.loading = false
    }
  }

  getErrorMessage(fieldName: string): string {
    if (this.userJoinRequestFormGroup.controls[fieldName].hasError('required')) {
      return this.translate.instant('FormErrorMessage.FieldValueRequired')
    }
    if (this.userJoinRequestFormGroup.controls[fieldName].hasError('email')) {
      return this.translate.instant('FormErrorMessage.EmailFieldEmailFormatError')
    }
    return ''
  }

  onClose() {
    this.handleCloseVisibility.emit()
  }

}
